module.exports = __webpack_public_path__ + "img/home-bg.9c258e37.png";